export default {
    NO_PICTURES: 'no pictures',
    ALIGN_LEFT: 'align left',
    ALIGN_RIGHT: 'align right',
    ALIGN_TOP: 'align top',
    ALIGN_BOTTOM: 'align bottom',
}



// WEBPACK FOOTER //
// ./web/src/common/templateTypes.js